import { useQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { GET_ALL_ALERGIAS } from '../../../../data/graphQL/queries/ResumenIngreso/getAllAlergias';
import { adaptAlergiaArray } from '../../../../adapters/alergiaAdapter';
import { SearchDiagnosticoCIE } from './components/SearchDiagnosticoCIE';

export const StepDatosGenerales2 = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI,
  pantallas,
  programOnlyCP
}) => {

  const [datosGenerales, setDatosGenerales] = useState(fullFormDataRI?.datosGenerales2 ?? {});
  const [antecedentesCombo, setAntecedentesCombo] = useState([]);
  const [antecedentesOtrosId, setAntecedentesOtrosId] = useState(-1);

  const [alergias, setAlergias] = useState([]);
  const [alergiaOtrosId, setAlergiaOtrosId] = useState(-1);

  const handleSubmit = () => {
    updateFormData(
      'datosGenerales2',
      datosGenerales,
      validatedinputsGroups.flatMap((x) => x.inputs)
    );
  };

  const handleChange = (name, value) => {
    setDatosGenerales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const { data: antecedentesData } = useQuery(getStringQueryCombosRI(antecedentesCampo), {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!antecedentesData) return;

    const newAntecedentesCombo = adaptCombosRIArray(antecedentesData)?.antecedentesClinicos;
    setAntecedentesCombo(newAntecedentesCombo);
    const otrosId = newAntecedentesCombo.find((x) => x.displayName.toLowerCase() === 'otros')?.id || -1;
    setAntecedentesOtrosId(otrosId);
  }, [antecedentesData]);

  const { data: alergiasData } = useQuery(GET_ALL_ALERGIAS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!alergiasData) return;

    const newAlergias = adaptAlergiaArray(alergiasData);
    setAlergias(newAlergias);
    const otrosId = newAlergias.find((x) => x.displayName.toLowerCase() === 'otros')?.id || -1;
    setAlergiaOtrosId(otrosId);
  }, [alergiasData]);

  const validatedinputsGroups = useMemo(() => {
    const idPantallaDI = pantallas.find((p) => p.displayName.includes('DI'))?.id;
    const hasProgramDI = selectedPrograms?.indexOf(idPantallaDI) > -1;

    const updatedRequired = structuredClone(inputsGroups).map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        const isNotRequired = hasProgramDI && notRequiredInDI.includes(input.name);
        input.required = isNotRequired ? false : input.required;
        const modulosSelected = fullFormDataRI?.datosGenerales1?.tiposModulos;
        switch (input.name) {
          case 'antecedentesClinicos':
            if (!antecedentesCombo) break;
            input.options = antecedentesCombo;
            break;
          case 'alergias':
            if (!alergias) break;
            input.options = alergias;
            break;
          case 'otrosAntecedentes':
            const hasOtrosAntecedentes = datosGenerales.antecedentesClinicos?.includes(antecedentesOtrosId);
            input.disabled = !hasOtrosAntecedentes;
            input.required = !!hasOtrosAntecedentes;
            break;
          case 'otrasAlergias':
            const hasOtrasAlergias = datosGenerales.alergias?.includes(alergiaOtrosId);
            input.disabled = !hasOtrasAlergias;
            input.required = !!hasOtrasAlergias;
            break;
          // Son requeridos excepto en DI
          case 'estableHemodinamicamente':
            input.required = !modulosSelected?.includes(7);
            break;
          case 'estableEnfermedad':
            input.required = !modulosSelected?.includes(7);
            break;
          case 'nivelConciencia':
            input.required = !modulosSelected?.includes(7);
            break;
          case 'escaras':
            input.required = !modulosSelected?.includes(7);
            break;
          case 'ostomias':
            input.required = !modulosSelected?.includes(7);
            break;
          case 'diagnosticoAlta':
            input.required = !programOnlyCP;
            input.hidden = programOnlyCP;
            break;
          default:
            break;
        }
        return input;
      })
    }));

    return updatedRequired;
  }, [
    selectedPrograms,
    datosGenerales.antecedentesClinicos,
    datosGenerales.alergias,
    alergias,
    antecedentesCombo,
    programOnlyCP]
  );

  useEffect(() => {
    if (!programOnlyCP) return;
    setDatosGenerales((prevDatos) => ({
      ...prevDatos,
      diagnosticoAlta: null
    }));
  }, [programOnlyCP]);

  useEffect(() => {
    if (!antecedentesCombo) return;

    const opcionNo = antecedentesCombo.find((x) => x.displayName.includes('NO'));
    const disableCondition = datosGenerales.antecedentesClinicos.includes(opcionNo?.id) ?
      (id) => id !== opcionNo?.id :
      (id) => datosGenerales.antecedentesClinicos.length ? id === opcionNo?.id : false;

    setAntecedentesCombo((prevAntecedentes) =>
      prevAntecedentes.map((ant) => ({ ...ant, disabled: disableCondition(ant.id) }))
    );
  }, [datosGenerales.antecedentesClinicos]);

  useEffect(() => {
    if (!alergias) return;

    const opcionNo = alergias.find((x) => x.displayName.includes('NO'));
    const disableCondition = datosGenerales.alergias.includes(opcionNo?.id) ?
      (id) => id !== opcionNo?.id :
      (id) => datosGenerales.alergias.length ? id === opcionNo?.id : false;

    setAlergias((prevAlergias) =>
      prevAlergias.map((ant) => ({ ...ant, disabled: disableCondition(ant.id) }))
    );
  }, [datosGenerales.alergias]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosGenerales, setDataSubmissionCallback, validatedinputsGroups]);

  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid
            container>
            {group.inputs.
              filter((input) => !input.hidden).
              map((input) => {
                return (
                  <React.Fragment key={`${group.groupName}-${input.name}`}>
                    {input.name !== 'diagnosticosRI' && <RenderInputByTypeMobile
                      grided
                      handleChange={handleChange}
                      input={input}
                      value={datosGenerales[input.name]} />
                    }
                    {input.name === 'diagnosticosRI' && <SearchDiagnosticoCIE
                      diagnosticosRIModel={datosGenerales.diagnosticosRI}
                      handleChange={handleChange} />
                    }
                  </React.Fragment>);

              })}
          </Grid>
        </div>
      )
      }
    </div>);

};

const antecedentesCampo = [{
  displayName: 'Antecedentes Clínicos relevantes',
  comboName: 'Antecedentes Clínicos relevantes',
  name: 'antecedentesClinicos'
}];

const inputsGroups = [
  {
    groupName: 'Resumen de HCL',
    inputs: [
      {
        displayName: 'Resumen de HCL',
        name: 'resumenHCL',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'Diagnóstico al alta',
        name: 'diagnosticoAlta',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'Diagnóstico CIE-10',
        name: 'diagnosticosRI',
        type: 'search',
        required: true
      },
      {
        displayName: 'Enf. que motiva el soporte es oncologica',
        name: 'enfermedadOncologica',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Antecedentes Clínicos Relevantes',
        name: 'antecedentesClinicos',
        type: 'multiple_select',
        options: [],
        required: true
      },
      {
        displayName: 'Otros Antecedentes',
        name: 'otrosAntecedentes',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'Comentarios relevantes de antecedentes',
        name: 'comentarioRelevante',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Alergias Relevantes',
        name: 'alergias',
        type: 'multiple_select',
        options: [],
        required: true
      },
      {
        displayName: 'Otras alergias',
        name: 'otrasAlergias',
        type: 'long_string',
        required: true
      },
      {
        displayName: 'Medicación habitual',
        name: 'medicacionHabitual',
        type: 'long_string',
        required: false
      }]

  },
  {
    groupName: 'Condición Clínica',
    inputs: [
      {
        displayName: 'Estable hemodinámicamente',
        name: 'estableHemodinamicamente',
        type: 'long_string',
        required: true
      }, {
        displayName: 'Estable de su enfermedad de base',
        name: 'estableEnfermedad',
        type: 'long_string',
        required: true
      }, {
        displayName: 'Nivel de conciencia normal',
        name: 'nivelConciencia',
        type: 'long_string',
        required: true
      }, {
        displayName: 'Escaras',
        name: 'escaras',
        type: 'long_string',
        required: true
      }, {
        displayName: 'Ostomías',
        name: 'ostomias',
        type: 'long_string',
        required: true
      }, {
        displayName: 'Otros relevantes',
        name: 'otrosRelevantes',
        type: 'long_string',
        required: false
      }]

  }];


const notRequiredInDI = [
  'alergias',
  'medicacionHabitual',
  'estableHemodinamicamente',
  'estableEnfermedad',
  'nivelConciencia',
  'escaras',
  'ostomias',
  'otrosRelevantes'];